let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b2Scm")).then(() => parcelRequire('5T7BQ'));